export function getAvatarName(name: string) {
  return name
    .replace(/\s\s+/g, " ")
    .split(" ")
    .slice(0, 2)
    .map((v: string) => v[0]);
}
